var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('ChildrenPage',{attrs:{"id":3,"imgs":[
   require('../assets/imgs/3-0.png') ]}})],1),_c('div',{staticClass:"activeImg"}),_c('div',{staticClass:"new content"})])}
var staticRenderFns = []

export { render, staticRenderFns }